import React from 'react';

import JourneyCard from '../common/JourneyCard';
import JourneyExperienceOverlay from './JourneyExperienceOverlay';

function JourneyDisabled({ journey }) {
  return (
    <JourneyExperienceOverlay>
      <div className='flex items-center justify-center w-full h-full'>
        <div className='flex flex-col max-w-md text-center'>
          <JourneyCard className='p-4'>
            <div className='text-primary'>
              Access to this journey is currently unavailable.
            </div>
          </JourneyCard>
        </div>
      </div>
    </JourneyExperienceOverlay>
  );
}

export default JourneyDisabled;
